var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('div',{key:_vm.Status,staticClass:"policy-status",style:({'color': _vm.color })},[_c('i',{class:_vm.icon}),_c('div',{staticClass:"policy-status-text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }